import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuItemService } from './sidebar/services/menu-itemservices';
import { AuthInterceptorService } from '../core/auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SearchComponent } from './search/search.component';
import { NzIconModule } from 'ng-zorro-antd/icon';

// import { LabelModule } from '@progress/kendo-angular-label';
// import { InputsModule } from '@progress/kendo-angular-inputs';
// import { LayoutModule } from '@progress/kendo-angular-layout';

import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { CheckboxComponent } from './checkbox/checkbox.component';
@NgModule({
    imports: [
        NzIconModule,
        CommonModule,
        FormsModule,
        NzSwitchModule,
        NzEmptyModule,
        ReactiveFormsModule
        // InputsModule,
        // LayoutModule,
        // LabelModule
    ],
    exports: [
        SearchComponent,
        CheckboxComponent
    ],
    declarations: [
        SearchComponent,
        CheckboxComponent
    ],
    providers: [MenuItemService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
    ],
})
export class SharedModule {}

